import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface WelcomeStepProps {
  onContinue: () => void;
}

export function WelcomeStep({ onContinue }: WelcomeStepProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <img src="/logo.png" alt="" aria-hidden className="h-16 w-auto" />
      <h2 className="mt-6 text-2xl font-bold tracking-tight">
        Welcome to <span className="font-serif italic text-primary">prayingmantis.cloud</span>
      </h2>
      <p className="mt-3 max-w-md text-muted-foreground">
        Let&apos;s connect your infrastructure so we can start protecting it.
        This wizard will guide you through connecting your identity provider,
        cloud accounts, endpoints, and notification preferences.
      </p>
      <div className="mt-4 rounded-lg border bg-muted/50 px-4 py-3 text-sm text-muted-foreground">
        Most steps are optional — you can skip any step and come back later.
      </div>
      <Button className="mt-8" size="lg" onClick={onContinue}>
        Get Started <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
    </div>
  );
}
